import { useContext, useState, useEffect, useRef } from 'react';

import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import Alert from '@mui/material/Alert';

import { Loader } from '@c';
import { useActions } from '@h';
import { authActions } from '@r/auth/authSlice';
import { ViewContext } from '../utils';

import styles from './AuthForm.module.scss';
import { FiArrowLeft } from 'react-icons/fi';

const AuthForm = ({}) => {
    const {
        alert,
        setAlert,
        alertTimer,
        setAlertTimer,
        setLoginPassAuth,
        setWebcamAuth,
    } = useContext(ViewContext);

    const { isLoading, schoolList } = useSelector(({ auth }) => auth);
    const { schoolListStart, loginByFormStart, toggleError } = useActions(authActions);

    const [openList, setopenList] = useState(false);
    const [schoolName, setSchoolName] = useState(
        (() => {
            const school = localStorage.getItem('schoolName');
            if (!school) {
                return '';
            } else if (
                !['undefined', undefined, null, 'null'].includes(school)
            ) {
                return school;
            }

            return '';
        })()
        // localStorage.getItem('schoolName')
        //     ? localStorage.getItem('schoolName')
        // : ''
    );
    const [schoolTitle, setSchoolTitle] = useState('');
    const [filteredList, setFilteredList] = useState([]);
    const [selectedItem, setSelectedItem] = useState(0);
    const [search, setSearch] = useState('');
    const [editing, setEditing] = useState(false);
    const selectRef = useRef(null);
    const inputRef = useRef(null);
    const clearingRef = useRef(false);

    useEffect(() => {
        schoolListStart();
    }, []);

    useEffect(() => {
        if (schoolList.length > 0 && schoolName && !schoolTitle) {
            const school = schoolList.find((el) => el.Name === schoolName);
            setSchoolTitle(school.Title);
        }
    }, [schoolList]);

    const formik = useFormik({
        initialValues: {
            password: '',
            schooltype: 'lms',
            username: '',
            school: '',
        },
        onSubmit: (values) => {
            loginByFormStart({ ...values, school: schoolName });
            setSchoolTitle('');
            localStorage.setItem('schoolName', schoolName);
        },
    });

    const selectSchool = (item) => {
        setopenList(false);
        setEditing(false);
        setSchoolTitle(item.Title);
        setSchoolName(item.Name);
        setSearch('');
    };

    const inputSchoolName = (e) => {
        setopenList(true);
        setSelectedItem(0);
        setSearch(e.target.value);
    };

    const openSchoolSearch = () => {
        if (clearingRef.current) {
            return;
        }

        setEditing(true);
        setSearch(schoolTitle);
        setSelectedItem(0);
        setopenList(true);
    };

    const closeSchoolSearch = () => {
        setEditing(false);
    };

    const handleInputClick = () => {
        if (!openList) {
            openSchoolSearch();
        }
    };

    const clearSearch = () => {
        clearingRef.current = true;

        setSearch('');
        setSelectedItem(0);
        setEditing(true);
        setopenList(true);

        if (inputRef.current) {
            inputRef.current.focus();
        }

        clearingRef.current = false;
    };

    useEffect(() => {
        const handler = (event) => {
            if (
                selectRef.current &&
                !selectRef.current.contains(event.target)
            ) {
                setEditing(false);
                setopenList(false);
            }
        };

        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, []);

    useEffect(() => {
        const query = search.toLowerCase().trim();

        if (!query) {
            setFilteredList(schoolList);
        } else {
            setFilteredList(
                schoolList.filter((item) =>
                    item.Title.toLowerCase().includes(query)
                )
            );
        }
    }, [search, schoolList]);

    useEffect(() => {
        const handler = (event) => {
            if (!openList) return;

            if (event.keyCode === 40) {
                event.preventDefault();
                selectedItem >= filteredList.length - 1
                    ? setSelectedItem(filteredList.length - 1)
                    : setSelectedItem(selectedItem + 1);
            } else if (event.keyCode === 38) {
                event.preventDefault();
                selectedItem <= 0
                    ? setSelectedItem(0)
                    : setSelectedItem(selectedItem - 1);
            } else if (event.keyCode === 13) {
                event.preventDefault();
                if (filteredList[selectedItem]) {
                    setopenList(false);
                    setEditing(false);
                    setSchoolTitle(filteredList[selectedItem].Title);
                    setSchoolName(filteredList[selectedItem].Name);
                    setSearch('');
                    if (document.activeElement) {
                        document.activeElement.blur();
                    }
                }
            } else if (event.keyCode === 27) {
                setopenList(false);
            }
        };

        document.addEventListener('keydown', handler);

        return () => {
            document.removeEventListener('keydown', handler);
        };
    }, [selectedItem, filteredList, openList]);

    return (
        <form
            className={styles.login_form}
            autoComplete="on"
            onSubmit={formik.handleSubmit}
        >
            <div
                className={styles.back}
                onClick={() => {
                    setLoginPassAuth(false);
                    setWebcamAuth(Boolean(alert.text));
                    toggleError(false);
                    clearTimeout(alertTimer);
                    setAlertTimer(null);
                    setAlert({});
                }}
            >
                <FiArrowLeft size={30} color="white" />
                <span>Назад</span>
            </div>
            <div
                className={styles.alert}
                onMouseEnter={() => clearTimeout(alertTimer)}
                onMouseLeave={() =>
                    alert.show &&
                    setAlertTimer(
                        setTimeout(
                            () =>
                                setAlert((prev) => ({ ...prev, show: false })),
                            2000
                        )
                    )
                }
            >
                <Alert
                    severity={alert.type}
                    variant="filled"
                    style={{ opacity: alert.show ? 1 : 0 }}
                >
                    {alert.text}
                </Alert>
            </div>
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <div className={styles.title}>
                        Выбрать учебное заведение:
                    </div>
                    <div className={styles.select} ref={selectRef}>
                        <div className={styles.inputWrapper}>
                            <input
                                ref={inputRef}
                                className={styles.selected}
                                placeholder="Учебное заведение не выбрано"
                                onChange={(e) => inputSchoolName(e)}
                                onFocus={openSchoolSearch}
                                onClick={handleInputClick}
                                onBlur={closeSchoolSearch}
                                value={editing ? search : schoolTitle}
                                readOnly={!editing}
                                autoComplete="school"
                            />
                            {(editing ? search : schoolTitle) && (
                                <button
                                    type="button"
                                    className={styles.clearButton}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={clearSearch}
                                    aria-label="Очистить поиск"
                                >
                                    ×
                                </button>
                            )}
                        </div>
                        {openList && (
                            <div className={styles.list}>
                                {filteredList.map((item, i) => (
                                    <div
                                        className={
                                            i === selectedItem
                                                ? styles.listElement +
                                                  ' ' +
                                                  styles.choice
                                                : styles.listElement
                                        }
                                        key={item.Name}
                                        onClick={() => selectSchool(item)}
                                        onMouseEnter={() => setSelectedItem(i)}
                                    >
                                        {item.Title}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <div className={styles.login_title2}>
                        Введите логин/пароль:
                    </div>
                    <input
                        className={styles.login_input}
                        name="username"
                        value={formik.values.username}
                        onChange={formik.handleChange}
                        placeholder="Логин"
                    />
                    <input
                        className={styles.pass_input}
                        name="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        type="password"
                        placeholder="Пароль"
                    />
                    <div className={styles.buttons}>
                        <button className={styles.input_btn}>Войти</button>
                        {/* <button
              type='button'
              className={styles.input_btn}
              onClick={() => {
                setLoginPassAuth(false)
                setWebcamAuth(false)
              }}
            >
              Назад
            </button> */}
                    </div>
                </>
            )}
        </form>
    );
};

export default AuthForm;
